var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"resource":"networkinterfaces","on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"status-module":"network","extra-info":_vm.extraInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }